<template>
  <div class="nullPageModule">
    <img src="../assets//image/null.webp" alt="" />
    <h2>正在开发中~</h2>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.nullPageModule {
  width: 100%;
  height: 50%;
  padding: 100px 0;
  text-align: center;
  img{
    width: 300px;
    height: 300px;
  }
}
</style>
